module.exports = __webpack_public_path__ + "img/mob_home_04.962db8c2.png";